import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, debounceTime, of, switchMap } from 'rxjs';
import { GENERIC_MESSAGES } from '../../util/constantes-mensajes';
import { Paginator } from '../models/paginator';
import { TableHeader } from '../models/table';
import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root'
})
export class PageableService {

  constructor(private http: HttpClient, private modalService: ModalService) { }
  /**
   * This function returns an observable of paginator calling the method requested by page
   * @param {string} url
   * @param {number} page
   * @param {string} header
   * @param {string} filter
   * @param {string} order
   * @returns {Observable<Paginator<T>>}
   */
  getData<T>(url: string, page: number, pageQuantity: number, header?: string, filter?: string, order?: string): Observable<Paginator<T>> {
    const params = {
      column: header ? `&columna=${header}` : '',
      value: filter ? `&valor=${filter}` : '',
      order: order ? `&ordenamiento=${order}` : '',
    }
    return this.http.get<Paginator<T>>(`${url}?pagina=${page}&tamanoPagina=${pageQuantity}${params.column}${params.value}${params.order}`);
  }

  /**
   *  This function returns an observable of paginator calling the method requested, it can receive search parameters
   * @param {BehaviorSubject} search$
   * @param {number} page
   * @param {string} method
   * @returns {Observable<Paginator<T>>}
   */
  searchData<T>(
    search$: BehaviorSubject<TableHeader | undefined>,
    page: number,
    pageQuantity: number,
    method: string
  ): Observable<Paginator<T>> {
    return search$.asObservable().pipe(
      debounceTime(500),
      switchMap(result => {
        return this.getData<T>(method, page, pageQuantity, result?.key, result?.value, result?.sort).pipe(
          catchError(() => {
            try {
              this.modalService.getConfirmacionModal({ message: GENERIC_MESSAGES.GET.ERROR_SEARCH, confirmTitle: "Cerrar", isError: true });
            } catch (_) { /* injector may be destroyed (e.g. during tests teardown) */ }
            const paginator: Paginator<T> = {
              content: [],
              numberOfElements: 0,
              totalPages: 1,
              totalElements: 0,
              number: 0
            };
            return of(paginator)
          })
        )
      }));
  }
}
